"use client";

import type { PlaceResult } from "@ishvaram/ui/hooks";
import PlaceAutocomplete from "./PlaceAutocomplete";
import { PlaceChip } from "./PlaceChip";

interface BirthPlaceLabels {
  birthPlace: string;
  changePlace: string;
  pickCityHint: string;
}

export function BirthPlaceField({
  id,
  labels,
  birthPlace,
  selectedPlace,
  setBirthPlace,
  setSelectedPlace,
  placeIsUnresolved,
  trackStart,
}: {
  id: string;
  labels: BirthPlaceLabels;
  birthPlace: string;
  selectedPlace: PlaceResult | null;
  setBirthPlace: (value: string) => void;
  setSelectedPlace: (place: PlaceResult | null) => void;
  placeIsUnresolved: boolean;
  trackStart: () => void;
}) {
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-[13px] font-semibold mb-2"
        style={{ color: "var(--ish-dark)" }}
      >
        {labels.birthPlace}
      </label>
      {selectedPlace ? (
        <PlaceChip
          place={selectedPlace}
          changeLabel={labels.changePlace}
          onChange={() => {
            trackStart();
            setSelectedPlace(null);
          }}
        />
      ) : (
        <PlaceAutocomplete
          id={id}
          value={birthPlace}
          onChange={(value) => {
            trackStart();
            setBirthPlace(value);
            setSelectedPlace(null);
          }}
          onSelect={(place) => {
            trackStart();
            setBirthPlace(place.display);
            setSelectedPlace(place);
          }}
        />
      )}
      {placeIsUnresolved && (
        <p className="mt-1.5 text-[11px] leading-snug" style={{ color: "var(--ish-text-faint)" }}>
          {labels.pickCityHint}
        </p>
      )}
    </div>
  );
}
